import React from "react";

const Content = () => {
    return (
        <>
            <main id="body-content">
                <section className="contact-callout bg-primary wide-tb-70 mb-spacer-md">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-3 col-sm-6">
                                <div className="row align-items-start">
                                    <div className="col-sm-auto col-2 text-center">
                                        <i className="icofont-wall-clock icofont-2x"></i>
                                    </div>
                                    <div className="col pl-0">
                                        <h5 className="mb-3 h5-xs fw-6">OPENING HOURS</h5>
                                        <div className="text">
                                            Monday - Friday 09.00 - 18.00<br />
                                            Saturday 09.00 - 14.00
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-lg-3 col-sm-6">
                                <div className="row align-items-start">
                                    <div className="col-sm-auto col-2 text-center">
                                        <i className="icofont-phone icofont-2x"></i>
                                    </div>
                                    <div className="col pl-0">
                                        <h5 className="mb-3 h5-xs fw-6">CALL US ANYTIME</h5>
                                        <div className="text">
                                            +88 (0) 101 0000 000 <br />
                                            +88 (0) 202 0000 001
                                            </div>
                                    </div>
                                </div>
                            </div>

                            <div className="w-100 d-none d-sm-block d-lg-none spacer-60"></div>

                            <div className="col-12 col-lg-3 col-sm-6">
                                <div className="row align-items-start">
                                    <div className="col-sm-auto col-2 text-center">
                                        <i className="icofont-envelope icofont-2x"></i>
                                    </div>
                                    <div className="col pl-0">
                                        <h5 className="mb-3 h5-xs fw-6">EMAIL US</h5>
                                        <div className="text">
                                            <a href="#" className="link-light">mail@logzee.com</a><br />
                                            <a href="#" className="link-light">support@logzee.com</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-lg-3 col-sm-6">
                                <div className="row align-items-start">
                                    <div className="col-sm-auto col-2 text-center">
                                        <i className="icofont-envelope-open icofont-2x"></i>
                                    </div>
                                    <div className="col pl-0">
                                        <h5 className="mb-3 h5-xs fw-6">Subscribe to Newsletter</h5>
                                        <div className="text">
                                            <a href="#" className="btn-theme bg-sky-blue light tra">
                                                Get Started Now!
                                                        </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="bg-white wide-tb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>WELCOME TO</span>
                                    LogZee Cargo
                                            </h1>
                            </div>

                            <div className="col-md-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.1s">
                                <a href="service-details.html">
                                    <div className="icon-box-1">
                                        <img src="images/icon-box-1.jpg" alt="" />
                                        <div className="text">
                                            <i className="icofont-vehicle-delivery-van"></i>
                                            GROUND DELIVERY
                                                    </div>
                                    </div>
                                </a>
                            </div>

                            <div className="col-md-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.4s">
                                <a href="service-details.html">
                                    <div className="icon-box-1">
                                        <img src="images/icon-box-2.jpg" alt="" />
                                        <div className="text">
                                            <i className="icofont-airplane-alt"></i>
                                            AIR DELIVERY
                                                    </div>
                                    </div>
                                </a>
                            </div>

                            <div className="col-md-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.6s">
                                <a href="service-details.html">
                                    <div className="icon-box-1">
                                        <img src="images/icon-box-3.jpg" alt="" />
                                        <div className="text">
                                            <i className="icofont-ship"></i>
                                            SEA DELIVERY
                                                    </div>
                                    </div>
                                </a>
                            </div>

                        </div>
                    </div>
                </section>

                <section className="bg-light-gray wide-tb-100 bg-wave">
                    <div className="container pos-rel">
                        <div className="row">
                            <div className="img-business-man">
                                <img src="images/business-man.png" alt="" />
                            </div>
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>Our Goodness</span>
                                    What Makes Us Special
                                            </h1>
                            </div>
                            <div className="col-md-8 ml-auto why-choose wow fadeInRight" data-wow-duration="0" data-wow-delay="0.6s">
                                <div className="row">
                                    <div className="col-12 col-lg-6">
                                        <div className="icon-box-2">
                                            <div className="media">
                                                <div className="service-icon">
                                                    <i className="icofont-id"></i>
                                                </div>
                                                <div className="service-inner-content media-body">
                                                    <h4 className="h4-md">Trusted Franchise</h4>
                                                    <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-6">
                                        <div className="icon-box-2">
                                            <div className="media">
                                                <div className="service-icon">
                                                    <i className="icofont-live-support"></i>
                                                </div>
                                                <div className="service-inner-content media-body">
                                                    <h4 className="h4-md">Customer Support</h4>
                                                    <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-100 spacer-60 d-none d-md-none d-lg-block d-sm-none"></div>

                                    <div className="col-12 col-lg-6">
                                        <div className="icon-box-2">
                                            <div className="media">
                                                <div className="service-icon">
                                                    <i className="icofont-history"></i>
                                                </div>
                                                <div className="service-inner-content media-body">
                                                    <h4 className="h4-md">Reliability & Punctuality</h4>
                                                    <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-6">
                                        <div className="icon-box-2">
                                            <div className="media">
                                                <div className="service-icon">
                                                    <i className="icofont-briefcase-1"></i>
                                                </div>
                                                <div className="service-inner-content media-body">
                                                    <h4 className="h4-md">Consulting Services</h4>
                                                    <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12 text-center">
                                    <div className="spacer-50">
                                    </div>
                                    <a href="#" className="btn-theme bg-primary">Request Quote <i className="icofont-rounded-right"></i></a>
                                    <div className="spacer-30">
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="wide-tb-100 bg-scroll counter-bg pos-rel">
                    <div className="bg-overlay blue opacity-50"></div>
                    <div className="container">
                        <div className="row">
                            <div className="col counter-style-1 col-6 col-lg-3 col-sm-6 wow fadeInLeft" data-wow-duration="0" data-wow-delay="0s">
                                <p><i className="icofont-google-map"></i></p>
                                <span className="counter">15</span>
                                <div>
                                    Our Locations
                                            </div>
                            </div>

                            <div className="col counter-style-1 col-6 col-lg-3 col-sm-6 wow fadeInLeft" data-wow-duration="0" data-wow-delay="0s">
                                <p><i className="icofont-globe"></i></p>
                                <span className="counter">110</span>
                                <span>+</span>
                                <div>
                                    Clients Worldwide
                                            </div>
                            </div>

                            <div className="w-100 d-none d-sm-block d-lg-none spacer-60"></div>

                            <div className="col counter-style-1 col-6 col-lg-3 col-sm-6 wow fadeInRight" data-wow-duration="0" data-wow-delay="0">
                                <p><i className="icofont-vehicle-delivery-van"></i></p>
                                <span className="counter">240</span>
                                <span>+</span>
                                <div>
                                    Owned Vehicles
                                            </div>
                            </div>

                            <div className="col counter-style-1 col-6 col-lg-3 col-sm-6 wow fadeInRight" data-wow-duration="0" data-wow-delay="0s">
                                <p><i className="icofont-umbrella-alt"></i></p>
                                <span className="counter">2340</span>
                                <div>
                                    Tonnes Transported
                                            </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-100 pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7 ml-lg-auto pos-rel col-md-12">

                                <h1 className="heading-main text-left">
                                    <span>get updates</span>
                                    Tracking Your Freight
                                            </h1>

                                <form className="form-inline tracking">
                                    <input type="text" className="form-control mb-2 mr-sm-2 col" placeholder="Enter order number" />
                                    <button type="submit" className="btn btn-theme bg-primary mb-2 ml-3">Check Now <i className="icofont-rounded-right"></i></button>
                                </form>

                                <div className="forklift-image wow slideInLeft" data-wow-duration="0" data-wow-delay="0s">
                                    <img src="images/forklift_Image.png" alt="" />
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <section className="bg-white wide-tb-100 mb-spacer-md">
                    <div className="container">
                        <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                            <h1 className="heading-main">
                                <span>Who we are</span>
                                About Us
                                        </h1>
                        </div>

                        <div className="row wow fadeInUp" data-wow-duration="0" data-wow-delay="0.2s">
                            <div className="col-lg-8">
                                <div className="about-bg bg-sky-blue">
                                    <div className="row d-flex align-items-end">
                                        <div className="col-12 pt-5 order-sm-12 col-sm-6">
                                            <blockquote className="blockquote style-one">
                                                <p className="mb-0">There is no design without discipline. There is no discipline without intelligence.</p>
                                                <footer className="blockquote-footer"><cite title="Source Title">Steven Snell Google</cite></footer>
                                            </blockquote>
                                        </div>
                                        <div className="col-12 mb-0 order-sm-1 col-sm-6">
                                            <img src="images/about_img.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="w-100 d-none d-sm-block d-lg-none spacer-60"></div>

                            <div className="col-lg-4">
                                <div className="align-self-stretch h-100 align-items-center d-flex bg-with-text">
                                    Whether you require distribution or fulfillment, defined freight forwarding, or a complete supply chain solution, we are here for you.
                                            </div>
                            </div>
                        </div>

                        <div className="row text-center mobile-100">
                            <div className="col-sm-12">
                                <div className="spacer-50"></div>
                                <a href="#" className="btn-theme bg-primary">Request Quote <i className="icofont-rounded-right"></i></a>
                                <a href="#" className="ml-5 link-oragne icon-left play-video"><i className="icofont-play"></i> Watch Our Short Video</a>
                            </div>
                            <div className="video-box">
                                <div className="close-video">
                                    <i className="fa fa-times"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-100 bg-fixed free-quote pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 col-md-7">
                                <div className="free-quote-form">
                                    <h1 className="heading-main mb-4">
                                        <span>Request a </span>
                                        Free Quote
                                                </h1>

                                    <form action="#" method="post" noValidate="novalidate" className="col rounded-field">
                                        <div className="form-row mb-4">
                                            <input type="text" name="name" className="form-control" placeholder="Your Name" />
                                        </div>
                                        <div className="form-row mb-4">
                                            <input type="text" name="email" className="form-control" placeholder="Email" />
                                        </div>
                                        <div className="form-row mb-4">
                                            <select title="Please choose a package" required="" name="package" className="custom-select" aria-required="true" aria-invalid="false">
                                                <option value="">Transport Type</option>
                                                <option value="Type 1">Type 1</option>
                                                <option value="Type 2">Type 2</option>
                                                <option value="Type 3">Type 3</option>
                                                <option value="Type 4">Type 4</option>
                                            </select>
                                        </div>
                                        <div className="form-row mb-4">
                                            <select title="Please choose a package" required="" name="package" className="custom-select" aria-required="true" aria-invalid="false">
                                                <option value="">Type of freight</option>
                                                <option value="Type 1">Type 1</option>
                                                <option value="Type 2">Type 2</option>
                                                <option value="Type 3">Type 3</option>
                                                <option value="Type 4">Type 4</option>
                                            </select>
                                        </div>
                                        <div className="form-row mb-4">
                                            <textarea rows="7" placeholder="Message" className="form-control"></textarea>
                                        </div>
                                        <div className="form-row text-center">
                                            <button type="submit" className="form-btn mx-auto btn-theme bg-secondary">Submit Now <i className="icofont-rounded-right"></i></button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>What Our</span>
                                    Customers Saying
                                            </h1>
                            </div>
                            <div className="col-sm-12">
                                <div className="owl-carousel owl-theme" id="home-client-testimonials">

                                    <div className="item">
                                        <div className="client-testimonial bg-wave">
                                            <div className="media">
                                                <div className="client-testimonial-icon rounded-circle bg-primary">
                                                    <img src="images/team_1.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="client-testimonial bg-wave">
                                            <div className="media">
                                                <div className="client-testimonial-icon rounded-circle bg-primary">
                                                    <img src="images/team_2.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="client-testimonial bg-wave">
                                            <div className="media">
                                                <div className="client-testimonial-icon rounded-circle bg-primary">
                                                    <img src="images/team_3.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-80 bg-primary callout-style-1 wow fadeInUp" data-wow-duration="0" data-wow-delay="0s">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-4 col-md-12 mb-0">
                                <h4 className="h4-xl">Interested in working with Logzee?</h4>
                            </div>
                            <div className="col">
                                <div className="center-text">
                                    We don’t just manage suppliers, we micro-manage them. We have a consultative, personalized approach
                                            </div>
                            </div>
                            <div className="col-sm-auto">
                                <a href="#" className="btn-theme bg-white light">Get In Touch <i className="icofont-rounded-right"></i></a>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>COMPANY'S NEWS</span>
                                    Recent Posts
                                            </h1>
                            </div>

                            <div className="col-sm-12 col-md-4 wow fadeInLeft" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="blog-warp">
                                    <img src="images/blog_img_1.jpg" alt="" className="rounded" />
                                    <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                    <h4 className="h4-md mb-3"><a href="#">Freight Payment and Auditing Services</a></h4>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="blog-warp">
                                    <img src="images/blog_img_2.jpg" alt="" className="rounded" />
                                    <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                    <h4 className="h4-md mb-3"><a href="#">Freight Payment and Auditing Services</a></h4>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4 wow fadeInRight" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="blog-warp">
                                    <img src="images/blog_img_3.jpg" alt="" className="rounded" />
                                    <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                    <h4 className="h4-md mb-3"><a href="#">Freight Payment and Auditing Services</a></h4>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-100 bg-fixed clients-bg pos-rel">
                    <div className="bg-overlay blue opacity-80"></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>SOME OF OUR</span>
                                    Clients
                                            </h1>
                            </div>

                            <div className="col-sm-12 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.2s">
                                <div className="owl-carousel owl-theme" id="home-clients">

                                    <div className="item">
                                        <img src="images/clients/client1.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client2.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client3.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client4.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client5.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client6.png" alt="" />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="map-bg">
                    <div className="contact-details row d-flex">
                        <div className="col">
                            <h4>Germany</h4>
                            <p><i className="icofont-phone"></i> +1 (408) 786 - 5117</p>
                            <div className="text-nowrap"><i className="icofont-email"></i> <a href="#">germany@logzee.com</a></div>
                        </div>
                        <div className="col">
                            <h4>Spain</h4>
                            <p><i className="icofont-phone"></i> +1 (408) 786 - 5117</p>
                            <div className="text-nowrap"><i className="icofont-email"></i> <a href="#">spain@logzee.com</a></div>
                        </div>
                    </div>
                    <div id="map-holder" className="pos-rel">
                        <div id="map_extended">
                            <p>This will be replaced with the Google Map.</p>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};
export default Content;
